<template>
  <div v-if="pageCount > 1" class="paa-pager">
    <template v-for="item in items">
      <span v-if="item.dots" :key="item.key" class="paa-pager__dots">...</span>
      <button
        v-else
        :key="item.key"
        type="button"
        :class="{ 'paa-on': item.page === page }"
        @click="$emit('change', item.page)"
      >{{ item.page }}</button>
    </template>
    <button type="button" aria-label="Previous page" :disabled="page <= 1" @click="$emit('change', page - 1)">&lsaquo;</button>
    <button type="button" aria-label="Next page" :disabled="page >= pageCount" @click="$emit('change', page + 1)">&rsaquo;</button>
  </div>
</template>

<script>
/** Design pager: the first two, the last two and the pages around the current one, dots for the gaps. */
export default {
  name: 'PopAuthorityAdminPager',
  props: {
    page: { type: Number, default: 1 },
    pageCount: { type: Number, default: 1 },
  },
  computed: {
    items () {
      const n = this.pageCount
      const out = []
      for (let i = 1; i <= n; i++) {
        if (n > 7 && i > 2 && i < n - 1 && Math.abs(i - this.page) > 1) {
          if (i === 3 || i === n - 2) out.push({ dots: true, key: `dots-${i}` })
          continue
        }
        out.push({ page: i, key: `page-${i}` })
      }
      return out
    },
  },
}
</script>
